'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var asterisk = require('./asterisk-436ee6b3.js');

var StyledTitle = styled__default.label(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  font: 14px ", ";\n  line-height: 22px;\n  font-style: normal;\n  font-weight: normal;\n  cursor: pointer;\n  overflow: hidden;\n  pointer-events: none;\n  color: ", ";\n"], ["\n  font: 14px ", ";\n  line-height: 22px;\n  font-style: normal;\n  font-weight: normal;\n  cursor: pointer;\n  overflow: hidden;\n  pointer-events: none;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var Title = function (_a) {
    var label = _a.label, _b = _a.required, required = _b === void 0 ? true : _b, dataCy = _a.dataCy, testId = _a.testId;
    if (!label) {
        return null;
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(StyledTitle, { "data-cy": dataCy, "data-testid": testId }, label),
        required && React__default.createElement(asterisk.Asterisk, { "data-testid": testId + "-Asterisk" })));
};
var templateObject_1;

exports.Title = Title;
